import { isFunction } from 'lodash';
import { NAVY } from 'styles/Colors';
import { Safari } from 'styles/MediaQueries';
import BankIcon from 'images/BankIcon.svg';
import CashDepositIcon from 'images/CashDepositIcon.svg';
import CtaButton from '@opploans/cta-button-component/CtaButton';
import IDIcon from 'images/IDIcon.svg';
import LocationIcon from 'images/LocationIcon.svg';
import PersonaIcon from 'images/RebrandPersona.png';
import React, { useEffect, useState } from 'react';
import TimeIcon from 'images/TimeIcon.svg';

const transitionDivStart = {
  '& > div': {
    opacity: '0',
    height: '100%'
  },
  '.loaded:nth-of-type(1)': {
    transition: 'opacity 800ms 1s',
    opacity: '1'
  },
  '.loaded:nth-of-type(2)': {
    transition: 'opacity 800ms 2s',
    opacity: '1'
  },
  '.loaded:nth-of-type(3)': {
    transition: 'opacity 800ms 3s',
    opacity: '1'
  },
  '.loaded:nth-of-type(4)': {
    transition: 'opacity 800ms 4s',
    opacity: '1'
  },
  '.loaded:nth-of-type(5)': {
    transition: 'opacity 800ms 5s',
    opacity: '1'
  },
  '.loaded:nth-of-type(6)': {
    transition: 'opacity 800ms 6s',
    opacity: '1'
  },
  '.loaded:nth-of-type(7)': {
    transition: 'opacity 800ms 7s',
    opacity: '1'
  }
};

const pageContainerStyle = {
  alignItems: 'center',
  display: 'flex',
  flexDirection: 'column',
  fontFamily: 'Arimo'
};

const pageHeaderStyle = {
  color: NAVY,
  fontSize: '1.5rem',
  fontWeight: 900,
  lineHeight: '1.75rem',
  marginBottom: '1.5rem',
  textAlign: 'center',
  width: '12.5rem',
  [Safari]: {
    letterSpacing: '-1px'
  }
};

const pageSubheaderStyle = {
  fontSize: '1.25rem',
  lineHeight: '1.5rem',
  marginBottom: '1.5rem',
  textAlign: 'center',
  width: '20.25rem'
};

const bulletStyle = {
  alignItems: 'center',
  display: 'flex',
  marginBottom: '1.25rem',

  p: {
    fontWeight: 400,
    lineHeight: '1.125rem'
  }
};

const iconContainerStyle = {
  alignItems: 'center',
  display: 'flex',
  height: '1.5rem',
  justifyContent: 'center',
  marginRight: '0.5rem',
  minWidth: '2.5rem',
  width: '2.5rem'
};

const iconStyle = {
  height: '4.7rem',
  margin: '0 10px'
};

const sideDivStyle = {
  backgroundImage: `radial-gradient(circle, ${NAVY} 8%, transparent 5%)`,
  backgroundSize: '20px 20px',
  width: '10rem',
  height: '1rem'
};

const headerGroupStyle = {
  display: 'flex',
  alignItems: 'center',
  width: '100%',
  justifyContent: 'center'
};

const buttonStyle = {
  fontSize: '1rem',
  height: '3.5rem',
  marginTop: '2.5rem',
  width: '100%'
};

const linkContainerStyle = {
  fontSize: '1rem',
  lineHeight: '1rem',
  marginBottom: '1rem',
  textAlign: 'center',
  padding: '1rem'
};
const linkStyle = {
  textDecoration: 'none',
  color: '#5D9CEC',
  transition: 'color 0.2s ease'
};

function IntroPage({ onClick }) {
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    setLoaded(true);
  }, []);

  const fadeInClass = loaded ? 'loaded' : '';

  const handleClick = () => {
    if (isFunction(onClick)) {
      onClick();
    }
  };
  return (
    <div css={pageContainerStyle}>
      <div css={headerGroupStyle}>
        <div css={sideDivStyle} />
        <div>
          <img src={PersonaIcon} alt='persona' css={iconStyle} />
        </div>
        <div css={sideDivStyle} />
      </div>
      <h1 css={pageHeaderStyle}>Welcome to your Loan Application!</h1>
      <h2 css={pageSubheaderStyle}>
        Before you get started, let&apos;s review our eligibility requirements.
      </h2>

      <div css={transitionDivStart}>
        <div css={bulletStyle} className={fadeInClass}>
          <div css={iconContainerStyle}>
            <IDIcon />
          </div>
          <p>Be at least 18 years old</p>
        </div>

        <div css={bulletStyle} className={fadeInClass}>
          <div css={iconContainerStyle}>
            <LocationIcon />
          </div>
          <p>
            Reside in one of the&nbsp;
            <a
              href='https://www.opploans.com/rates-and-terms/'
              target='_blank'
              rel='noreferrer'
            >
              states we service
            </a>
          </p>
        </div>

        <div css={bulletStyle} className={fadeInClass}>
          <div css={iconContainerStyle}>
            <TimeIcon />
          </div>
          <p>Have a regular source of income</p>
        </div>

        <div css={bulletStyle} className={fadeInClass}>
          <div css={iconContainerStyle}>
            <BankIcon />
          </div>
          <p>Have a checking or a savings account</p>
        </div>

        <div css={bulletStyle} className={fadeInClass}>
          <div css={iconContainerStyle}>
            <CashDepositIcon />
          </div>
          <p>Receive paychecks through direct deposit</p>
        </div>
        <div className={fadeInClass}>
          <CtaButton
            id='submitButton'
            additionalStyle={buttonStyle}
            onClick={handleClick}
          >
            Start New Application
          </CtaButton>
        </div>

        <div css={linkContainerStyle} className={fadeInClass}>
          <a css={linkStyle} href='/auth/login'>
            Previously Applied? Log in here.
          </a>
        </div>
      </div>
    </div>
  );
}

export default IntroPage;
